import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { Lock, Loader2, ArrowRight } from "lucide-react";
import { api } from "@/lib/api";

// Server-side authorization gate for a paid lab product.
// Renders children only if the current user owns/has-access to `product`.
export function LabGate({ product, name, children }) {
  const [state, setState] = useState("checking"); // checking | allow | deny
  const navigate = useNavigate();

  useEffect(() => {
    let active = true;
    api.get("/catalog").then(({ data }) => {
      if (!active) return;
      const lab = (data.labs || []).find((l) => l.slug === product);
      setState(lab && lab.owned ? "allow" : "deny");
    }).catch(() => active && setState("deny"));
    return () => { active = false; };
  }, [product]);

  if (state === "checking") {
    return <div className="h-screen grid place-items-center bg-background" data-testid="labgate-checking"><Loader2 className="h-7 w-7 animate-spin text-muted-foreground" /></div>;
  }
  if (state === "deny") {
    return (
      <div className="h-screen grid place-items-center bg-background p-6" data-testid="labgate-locked">
        <div className="max-w-md w-full rounded-2xl border border-border bg-card p-8 text-center shadow-xl">
          <div className="mx-auto h-14 w-14 rounded-full bg-amber-500/15 grid place-items-center mb-4"><Lock className="h-7 w-7 text-amber-500" /></div>
          <h1 className="text-2xl font-bold mb-2">{name || "This lab"} is locked</h1>
          <p className="text-muted-foreground mb-6 text-sm">You need an active subscription to open this lab. It's $50/month — subscribe to get instant access.</p>
          <button data-testid="labgate-subscribe" onClick={() => navigate(`/billing?lab=${product}`)} className="w-full h-11 rounded-lg bg-[#0078d4] hover:bg-[#106ebe] text-white font-semibold flex items-center justify-center gap-2">Subscribe to {name} <ArrowRight className="h-4 w-4" /></button>
          <button onClick={() => navigate("/billing")} className="w-full h-10 mt-2 rounded-lg text-muted-foreground hover:text-foreground text-sm">Browse all labs</button>
        </div>
      </div>
    );
  }
  return children;
}
